import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AdminService } from '../../service/admin.service';
import { create } from 'domain';

export interface IntegrationValues {
  apiToken: string;
  homeUrl: string;
  updatedAt: string;
  allowedDomains: string[];
  clientSecret: string;
  updatedBy: string;
  isEnabled: boolean;
  clientId: string;
}
export interface Integration {
  name: string;
  integrationId: string;
  dev: IntegrationValues;
  prod: IntegrationValues;
  iconUrl?: string;
}

type IntegrationState = {
  integrations: Integration[];
  loading: boolean;
  error: string | null;
};

const initialState: IntegrationState = {
  integrations: [],
  loading: false,
  error: null,
};

export const fetchIntegrations = createAsyncThunk('integration/fetchIntegrations', async () => {
  const data = await AdminService.getAllIntegrations();
  return data;
});

export const addIntegration = createAsyncThunk(
  'integration/addIntegration',
  async (payload: any) => {
    const data = await AdminService.addIntegration(payload);
    return data;
  },
);
export const editIntegrationIcon = createAsyncThunk(
  'integration/editIntegrationIcon',
  async ({ integrationId, payload }: { integrationId: string; payload: any }) => {
    const data = await AdminService.editIntegrationIcon(integrationId, payload);
    return data;
  },
);

export const updateIntegration = createAsyncThunk(
  'integration/updateIntegration',
  async ({ integrationId, payload }: { integrationId: string; payload: any }) => {
    const data = await AdminService.updateIntegration(integrationId, payload);
    return data;
  },
);

const integrationSlice = createSlice({
  name: 'integration',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchIntegrations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIntegrations.fulfilled, (state, action) => {
        state.loading = false;
        state.integrations = action.payload.integrations || [];
      })
      .addCase(fetchIntegrations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch integrations';
      })
      .addCase(addIntegration.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addIntegration.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addIntegration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to add integration';
      })
      .addCase(updateIntegration.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateIntegration.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateIntegration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to update integration';
      });
  },
});

export const { clearError } = integrationSlice.actions;
export default integrationSlice.reducer;
